/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMCPCatalogSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMCPCatalogSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMCPCatalogSecurity = {
  option1?: ListMCPCatalogSecurityOption1 | undefined;
  option2?: ListMCPCatalogSecurityOption2 | undefined;
};

export type ListMCPCatalogRequest = {
  /**
   * Filter to a specific registry
   */
  registryId?: string | undefined;
  /**
   * Search query to filter servers by name
   */
  search?: string | undefined;
  /**
   * Pagination cursor
   */
  cursor?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMCPCatalogSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMCPCatalogSecurityOption1$outboundSchema: z.ZodMiniType<
  ListMCPCatalogSecurityOption1$Outbound,
  ListMCPCatalogSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMCPCatalogSecurityOption1ToJSON(
  listMCPCatalogSecurityOption1: ListMCPCatalogSecurityOption1,
): string {
  return JSON.stringify(
    ListMCPCatalogSecurityOption1$outboundSchema.parse(
      listMCPCatalogSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMCPCatalogSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMCPCatalogSecurityOption2$outboundSchema: z.ZodMiniType<
  ListMCPCatalogSecurityOption2$Outbound,
  ListMCPCatalogSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listMCPCatalogSecurityOption2ToJSON(
  listMCPCatalogSecurityOption2: ListMCPCatalogSecurityOption2,
): string {
  return JSON.stringify(
    ListMCPCatalogSecurityOption2$outboundSchema.parse(
      listMCPCatalogSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMCPCatalogSecurity$Outbound = {
  Option1?: ListMCPCatalogSecurityOption1$Outbound | undefined;
  Option2?: ListMCPCatalogSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMCPCatalogSecurity$outboundSchema: z.ZodMiniType<
  ListMCPCatalogSecurity$Outbound,
  ListMCPCatalogSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMCPCatalogSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMCPCatalogSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMCPCatalogSecurityToJSON(
  listMCPCatalogSecurity: ListMCPCatalogSecurity,
): string {
  return JSON.stringify(
    ListMCPCatalogSecurity$outboundSchema.parse(listMCPCatalogSecurity),
  );
}

/** @internal */
export type ListMCPCatalogRequest$Outbound = {
  registry_id?: string | undefined;
  search?: string | undefined;
  cursor?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMCPCatalogRequest$outboundSchema: z.ZodMiniType<
  ListMCPCatalogRequest$Outbound,
  ListMCPCatalogRequest
> = z.pipe(
  z.object({
    registryId: z.optional(z.string()),
    search: z.optional(z.string()),
    cursor: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      registryId: "registry_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMCPCatalogRequestToJSON(
  listMCPCatalogRequest: ListMCPCatalogRequest,
): string {
  return JSON.stringify(
    ListMCPCatalogRequest$outboundSchema.parse(listMCPCatalogRequest),
  );
}
